// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user_popper{max-height:266px;overflow-y:auto}.editabale-cell-edit-view{z-index:120001!important}", ""]);
// Exports
module.exports = exports;
